import React from 'react'

// import mus from "../img/mus.jpg";
import gitara0 from "../img/gitara0.jpg"
import gitara1 from "../img/gitara1.jpg"
import gitara2 from "../img/gitara2.jpg"
// import gitara3 from "../img/gitara3.jpg"

import piano1 from "../img/piano1.jpg"
import piano2 from "../img/piano2.jpg"
import vokal from "../img/vokal1.jpg"

export default function Music() {
  return (
    <div>
    <section className="jarallax dark-mode bg-dark py-5" datajarallax dataspeed="0.6">
    <div className="position-absolute top-0 start-0 w-100 h-100 bg-black opacity-60"></div>
    <div className="jarallax-img" style={{backgroundImage: 'url(assets/img/landing/corporate/piano.jpg'}}></div>
    <div className="container position-relative zindex-2 pt-5 pb-md-2 pb-lg-3 pb-xl-4 pb-xxl-5">
        <div className="d-lg-flex position-relative h-100" style={{ position: "relative" }}>
          <a className="text-nav btn btn-icon bg-light border rounded-circle position-absolute top-0 end-0 p-0 mt-3 me-3 mt-sm-4 me-sm-4" href="/" data-bs-toggle="tooltip" data-bs-placement="left" title="Back to home"><i className="ai-home"></i></a>
        </div>
      <div className="d-none d-xxl-block" style={{height: "170px"}}></div>
      <div className="d-none d-lg-block d-xxl-none" style={{height: "120px"}}></div>
      <div className="d-none d-md-block d-lg-none" sstyle={{height: "80px"}}></div>
      <div className="d-md-none" style={{height: "40px"}}></div>
      <h1 className="display-2 mb-4 py-5 text-uppercase">Музыкальное направление</h1>
      <p className="mb-0 lead text-white" >
         Дети и взрослые: Фортепиано, Гитара, Вокал
      </p>
      <div className="d-none d-xxl-block" style={{height: "220px"}}></div>
      <div className="d-none d-lg-block d-xxl-none" style={{height: "160px"}}></div>
      <div className="d-none d-md-block d-lg-none" style={{height: "100px"}}></div>
      <div className="d-md-none" style={{height: "50px"}}></div>
      <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4 pb-1 pb-md-3">
        <div className="col">
          <div className="d-flex align-items-center">
            <div className="position-rlative flex-shrink-0 rounded-1 overflow-hidden p-2">
              <div className="bg-white opacity-40 position-absolute top-0 start-0 w-100 h-100"></div>
              <img className="d-block m-1" src="assets/img/services/v3/icons/time-white.svg" width="32" alt="Icon"/>
            </div>
            <h3 className="h5 ps-3 mb-0">Индивидуальный подход</h3>
          </div>
        </div>
        <div className="col">
          <div className="d-flex align-items-center">
            <div className="position-rlative flex-shrink-0 rounded-1 overflow-hidden p-2">
              <div className="bg-white opacity-40 position-absolute top-0 start-0 w-100 h-100"></div>
              <img className="d-block m-1" src="assets/img/services/v3/icons/cog-white.svg" width="32" alt="Icon"/>
            </div>
            <h3 className="h5 ps-3 mb-0">Творчество с удовольствием</h3>
          </div>
        </div>
        <div className="col">
          <div className="d-flex align-items-center">
            <div className="position-rlative flex-shrink-0 rounded-1 overflow-hidden p-2">
              <div className="bg-white opacity-40 position-absolute top-0 start-0 w-100 h-100"></div>
              <img className="d-block m-1" src="assets/img/services/v3/icons/monitor-white.svg" width="32" alt="Icon"/>
            </div>
            <h3 className="h5 ps-3 mb-0">Шаг за шагом играй и развивайся</h3>
          </div>
        </div>
        {/* <div className="col">
          <div className="d-flex align-items-center">
            <div className="position-rlative flex-shrink-0 rounded-1 overflow-hidden p-2">
              <div className="bg-white opacity-40 position-absolute top-0 start-0 w-100 h-100"></div>
              <img className="d-block m-1" src="assets/img/services/v3/icons/size-white.svg" width="32" alt="Icon"/>
            </div>
            <h3 className="h5 ps-3 mb-0">Полный спектр услуг: от мастер-классов до питание</h3>
          </div>
        </div> */}
      </div>
    </div>
  </section>

  <section className="container py-4 py-sm-2 my-md-2 my-lg-3 my-xl-4 my-xxl-5">
        <div className="row align-items-center py-4 py-xl-3 my-2">
          <div className="col-md-6 offset-xl-1 order-md-2 pb-2 mb-4 mb-md-0">
            {/* <img className="rounded-5" src={mus} alt="piano"/>
            <p></p>
            <br/>
            <p></p> */}
            <img className="rounded-5" src={piano1} alt="piano"/>
            <p></p>
            <br/>
            <img className="rounded-5" src={piano2} alt="piano"/>
          </div>
          <div className="col-md-6 col-xl-5 order-md-1">
            <div className="pe-md-4 pe-xl-0">
              <h2 className="pb-2 pb-lg-3">
                Для детей и взрослых:
              </h2>
              <ol className="fs-lg"> 
              <p className='h5'>Направления:</p>
                <li> Фортепиано - побуждает быть уточненным и элегантным, 
                <br/> Отлично подходит для правильного отдыха душой</li> 
                <li> Гитара - заряжает позитивными эмоциями и дает возможность завладеть вниманием всей компании или покорить целый стадион
                </li>
                <li> Вокал - вдохновляет и направляет вашу энергию на творчество, самовыражение через звуки и ноты, познакомьтесь с своим речевым аппаратом ближе на занятиях.
                </li>
              </ol>
              <p className="fs-lg">
                Вы можете записаться на индивидуальные занятия или в группы.
                Рекомендуемая интенсивность: 2 раза в неделю по 40/60 минут. </p> 
              <div className="row row-cols-1">
                <div className="col">
                  <h3 className="h4 mb-2">Музыкальное направление Фортепиано и Скрипка:</h3>
                  <p className='fs-lg'>Игра на пианино — это увлекательное и творческое занятие, которое приносит радость и удовлетворение, побуждает быть утонченным и элегантным.</p>
                  <p className='fs-lg'>Скрипка - это как поет душа.</p>
                  <ol className="fs-lg mb-0">
                    <p className='fs-lg'>Вот несколько шагов, которые помогут вам начать этот путь:</p>
                    <li><strong>Запишитесь к нам</strong> на пробное занятие и выберите удобный график. Наш педагог поможет вам освоить базовые навыки игры на пианино и даст необходимые советы по технике исполнения.</li>
                    <li><strong>Выбор инструмента:</strong> Решите, какой инструмент подходит вам больше всего. Можно выбрать акустическое пианино, цифровое пианино или синтезатор. Важно, чтобы инструмент был удобным и соответствовал вашим потребностям.</li>
                    <li><strong>Регулярные тренировки:</strong> Практика — ключ к успеху. Старайтесь заниматься ежедневно, даже если это всего лишь 15 минут. Постепенно увеличивайте продолжительность занятий.</li>
                    <li><strong>Теория музыки:</strong> Изучайте основы теории музыки. Это поможет вам лучше понимать структуру музыкальных произведений и облегчит процесс обучения.</li>
                    <li><strong>Игра любимых мелодий:</strong> Выберите песни или композиции, которые вам нравятся, и попробуйте сыграть их. Это сделает процесс обучения более интересным и мотивирующим.</li>
                    <li><strong>Участие в концертах и выступлениях:</strong> Когда почувствуете себя уверенно, вы сможете принять участие в концертных мероприятиях или играть для друзей и близких. Это поможет преодолеть страх сцены и повысит вашу уверенность в себе.</li>
                    <li><strong>Постоянное совершенствование: </strong>Не останавливайтесь на достигнутом. Продолжайте изучать новые техники и стили игры, экспериментируйте с различными жанрами музыки.</li>
                  </ol>
                  <br/>
                  <p className="fs-lg">Помните, что главное — это желание и упорство. Игра на пианино требует времени и усилий, но результат стоит того.
                    <br/>Наслаждайтесь процессом обучения и наслаждайтесь музыкой!
                  </p>
                </div> 
                <p></p>
                {/* <p className="fs-lg">Работа с различными материалами: пластилин, глина, тесто, аппликация и пр.
                <br/> Вы можете записаться на индивидуальные занятия или в группы.
                <br/> Рекомендуемая интенсивность: 2 раза в неделю по 40/60 минут.</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="row align-items-center py-4 py-xl-3 my-2">
          <div className="col-md-6 pb-2 mb-4 mb-md-0">
            <img className="rounded-5" src={gitara0} alt="Gitara"/>
            <p></p>
            <br/>
            <img className="rounded-5" src={gitara1} alt="Gitara"/>
            <p></p>
            <br/>
            <img className="rounded-5" src={gitara2} alt="Gitara"/>
            <p></p>
            <br/>
            <img className="rounded-5" src={vokal} alt="Sing"/>
          </div>
          <div className="col-md-6 col-xl-5 offset-xl-1">
            <div className="ps-md-4 pe-xl-0">
              <div className="row row-cols-1">
                <div className="col">
                  <h3 className="h4 mb-2">Музыкальное направление Гитара: <br/> Для детей от 7 лет и подростков</h3>
                  <p className='fs-lg'>Научим каждого, независимо от возраста и наличия музыкального слуха играть на гитаре. Нет, слух конечно важен. Тогда и результат лучше. Но главное – интерес и желание. В этом случае – и мотивация добавляется уже. А значит можно развить МАСТЕРСТВО игры на гитаре.</p>
                  <p className='fs-lg'>Обучение проводится по авторской методике, которая позволяет достичь каждому ученику поставленных целей.</p>
                  <ol className="fs-lg mb-0"> 
                    <p className="fs-lg"><strong>Польза от игры на гитаре: </strong> </p>
                    <li>Развитие навыков: когнитивной и мышечной памяти, мелкой моторики и логического мышления, музыкального слуха, фантазии и креативности.</li>
                    <li>Повышение мозговой активности и концентрации.</li>
                    <li>Укрепляет мышцы предплечий и запястий.</li>
                  </ol>
                  <br/>
                  <ul className="fs-lg mb-0"> 
                    <p className="fs-lg"><strong>Мы гарантируем: </strong> </p>
                    <li>Индивидуальный подход для каждого ученика.</li>
                    <li>С нуля до результата за 3 месяца <strong>при вашей полной вовлеченности</strong>.</li>
                    <li>На уроках мы используем минимум теории и максимум практики.</li>
                  </ul>
                </div> 
                <p></p>
                <p className="fs-lg">Наша главная идея – создать музыкальное пространство, где каждый может воплотить в жизнь свою мечту.
                <br/> Индивидуальные занятия 1 академический час (45 минут).
                <br/> Рекомендуемая интенсивность 2 раза в неделю.</p>
              </div>
              <p></p>
              <div className="row row-cols-1">
                <div className="col">
                  <h3 className="h4 mb-2">Музыкальное направление Вокал:</h3>
                  <p className='fs-lg'>Курсы вокала — это отличный способ развить свои музыкальные способности и научиться красиво петь. 
                    Они подходят для людей любого возраста и уровня подготовки, от начинающих до опытных музыкантов. 
                    Вокальные курсы предлагают разнообразные стили пения, такие как эстрадный, джазовый, классический, народный и другие,
                    а также возможность изучать песни на разных языках.</p>
                  <p className='fs-lg'><strong>Содержание курса</strong></p>
                  <ol className="fs-lg mb-0">
                    <p className="fs-lg">Программа курса подбирается индивидуально для каждого ученика, учитывая его пожелания и уровень подготовки. Занятия включают следующие темы: </p>
                    <li><strong>Проработка интонирования:</strong> Работа над точным воспроизведением звуков и нот.</li>
                    <li><strong>Работа над ритмом и темпом:</strong> Развитие чувства ритма и умение держать темп.</li>
                    <li><strong>Правильное дыхание:</strong> Обучение технике дыхания, необходимой для пения.</li>
                    <li><strong>Сольфеджио и теория музыки:</strong> Изучение основ музыкальной теории для лучшего понимания музыки.</li>
                    <li><strong>Упражнения для улучшения голоса:</strong> Развитие силы, тембра и индивидуальности голоса.</li>
                    <li><strong>Снятие зажимов и блоков:</strong> Упражнения для снятия физических и эмоциональных зажимов, которые могут мешать пению.</li>
                    <li><strong>Публичные выступления:</strong> Подготовка к выступлениям на сцене, работа с микрофоном.</li>
                    <li><strong>Артикуляция и дикция: </strong>Развитие четкости произношения и выразительности речи.</li>
                    <li><strong>Современные вокальные приемы:</strong> Изучение современных техник и приемов пения.</li>
                    <li><strong>Аккомпанирование:</strong> Обучение аккомпанементу на гитаре или фортепиано.</li>
                    <li><strong>Стиль акапело и под минусовку:</strong> Развитие навыков пения без музыкального сопровождения или под фонограмму.</li>
                  </ol> 
                  <br/>
                  <ul className="fs-lg mb-0"> 
                    <p className="fs-lg"><strong>Достоинства курса:</strong> </p>
                    <li><strong>Индивидуальный подход:</strong> Подбор программы и педагога осуществляется с учетом ваших пожеланий и уровня подготовки.</li>
                    <li><strong>Опытные преподаватели:</strong> Преподаватели — профессиональные музыканты с большим опытом работы.</li>
                    <li><strong>Разнообразие форматов и цен:</strong> Возможность выбрать удобный формат занятий и способ оплаты.</li>
                    <li><strong>Обучение для всех возрастов:</strong> Курсы подходят для любого возраста, от 7 до 70 лет.</li>
                    <li><strong>Обучение "с нуля":</strong> Подходит как для начинающих, так и для уже играющих музыкантов.</li>
                  </ul>
                </div> 
                <p></p>
                <p className="fs-lg">Курсы вокала — это отличный способ развить свои музыкальные способности, 
                  улучшить навыки общения и самовыражения, а также получить удовольствие от пения.</p>
              </div>
            </div>
          </div>
        </div>
        {/* <div>
          <h4 className="mb-lg-4">РЕЗУЛЬТАТ ОТ РАБОТЫ В ПРОГРАММАХ:</h4>
          <p className="fs-lg">Определим, какая профессия позволит подростка максимально раскрыть его потенциал, таланты и суперсилы.
            Он сам сможет понять: «Это моё».</p> 
            <ul className="fs-lg mb-0">
                    <li>Выберем специальность, которая позволит реализовать себя на 100% и быть успешным в будущем.</li>
                    <li> Научимся эффективно планировать свое время и все успевать в течение дня.</li>
                    <li>Поставим личную цель, которая будет вдохновлять и мотивировать к учебе.</li>
                    <li>Сформируем систему ценностей. приверженность к ней и полезную поддерживающую среду.</li>
                    <li>Родитель получает развернутую обратную связь о проделанной работе!</li>
            </ul>
            <p className="fs-lg mb-0">По итогам программ «Моя траектория» и «Инвестиции в себя» выдаются сертификаты. </p>
        </div> */}
        <br/>
        <div className="pb-2">
              <h4 className="mb-lg-3"> Подробности о направлении и наличие мест уточняйте у администратора или Developskillsnow  
              {/* <a className="nav-link fs-lg p-0" href="mailto:developskillsnow@yandex.ru">developskillsnow@yandex.ru</a> */}
              {/* <p className="lead"> */}
              <a className="btn btn-icon btn-md btn-light btn-linkedin rounded-circle mx-2" href="https://vk.com/developskillsnow"><i className="ai-vk"> </i> </a> 
              <a className="btn btn-icon btn-md btn-light btn-linkedin rounded-circle mx-2" href="https://www.instagram.com/developskillsnow"><i className="ai-instagram"> </i> </a> 
              </h4>
              <a className="nav-link fs-lg p-0" href="tel:+7 (992) 300-65-46"> Запись по телефонам: +7 (992) 300-65-46, +7 (992) 300-65-23</a>
            </div>
       
      </section>
  </div>
  )
}
